import type { UseQueryOptions } from "@pinia/colada";

import { useQuery } from "@pinia/colada";
import { until } from "@vueuse/core";

async function useQueryAsync<TResult, TError = Error>(
  options: UseQueryOptions<TResult, TError>,
): Promise<TError | TResult> {
  const query = useQuery(options);

  await Promise.any([
    until(query.status).toBe("success"),
    until(query.status).toBe("error"),
  ]);

  if (query.data.value !== undefined && query.data.value !== null) {
    return query.data.value;
  }

  return query.error.value as TError;
}

export { useQueryAsync };
